
import React, { useState, useEffect } from "react";
import api from "../Services/api";
import { generatePath, useNavigate } from "react-router-dom";
import { PulseLoader } from 'halogenium';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination]);

const ViverNoticias = () => {

    let navigate = useNavigate();
    const [nextPage, setNextPage] = useState<any[]>([]);
    const [noticias, setNoticias] = useState<any[]>([]);
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadmore, setLoadmore] = useState(false);


    /**
     * Carrega mais itens
     */
    const loadMore = () => {
        setLoading(true);
        setLoadmore(true);
        setTimeout(() => {
            setNoticias([...noticias, ...nextPage.slice(0, 3)]);
            setNextPage(nextPage.slice(3));
            if (nextPage.slice(3).length === 0) {
                setLoadmore(false);
            }
            setLoading(false);

        }, 1000);
    }

    function managePagination(data: any) {

        setNotFound(false);

        if (data.length > 0) {
            if (data.length > 3) {
                setNoticias(data.slice(0, 3));
                setNextPage(data.slice(3));
                setLoadmore(true);
            } else {
                setNoticias(data);
            }
        }
        else {
            setNotFound(true);
        }
    }

    useEffect(() => {
        // ObterNoticiasFiltro?Ano=2022&Mes=2&Categoria=7
        const categoriaId = 23
        api.get(`ObterNoticiasFiltro?Categoria=${categoriaId}`)
            .then(response => {
                managePagination(response.data.results);
            })
            .catch(error => {
                throw new Error(error);
            });
    }, []);


    //arrows
    const [swiperIndex, setSwiperIndex] = useState(0);

    const handlePrevClick = () => {
        setSwiperIndex((prevIndex) => prevIndex - 1);
    };

    const handleNextClick = () => {
        setSwiperIndex((prevIndex) => prevIndex + 1);
        console.log(swiperIndex)
    }

    const isPrevDisabled = swiperIndex === 0; // Disable prev button when swiperIndex is 0
    const isNextDisabled = swiperIndex === noticias.length; // Disable next button when swiperIndex is at the maximum




    const Setlocation = (id: any, nav: boolean) => {
        var url = id.Title;
        var Id = id.Id;
        var urlParamTrim = url?.substring(0, 50).normalize("NFD").replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, '-');
        if (urlParamTrim === undefined || urlParamTrim == null) {
            urlParamTrim = "Noticias...";
        } else {
            urlParamTrim = urlParamTrim + "...";

        }
        var searchParams = new URLSearchParams(urlParamTrim);
        searchParams.set("Id", Id);
        var path = "/noticias-internas/" + searchParams.toString();
        if (nav) {
            navigate(generatePath(path));
        } else {
            return generatePath(path);
        }
    }

    /**
     * Formata data
     * @param dateUtc 
     * @returns 
     */
    function formatDateAno(dateUtc: any) {
        if (dateUtc) {
            return new Date(dateUtc).getDate() + ' de ' + new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' }).toString() + ' de '
                + new Date(dateUtc).getFullYear().toString();
        }
    }

    const years = [];
    for (let i = 2010; i <= new Date().getFullYear(); i++) {
        years.push(i);
    }
    years.reverse();

    function ReplaceUrl(_url: any) {

        _url = _url?.toLowerCase();

        if (_url == null || _url === undefined || _url === "" || _url.includes("croacia")) {
            return '../assets/img/noticias-default.png';
        }

        if (_url) {
            return _url.replace("http:", "https:");
        }
        else {
            return '../assets/img/noticias-default.png';
        }
    }

    function addDefaultSrcViver(ev: any) {
        ev.target.src = '../assets/img/noticias-default.png';
    }

    return (
        <>
            <div key={new Date().getTime()} className="_the-content page-noticias pt-2 mb-8">

                <div className="resultados">
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className="col-lg-10 col-xl-12">
                                <div className="row loaded position-mobile">

                                    <div className="desktop">

                                        <div className="row">
                                            {noticias?.map((item, index) => (

                                                <div key={index} className='col-lg-4 col-md-3 load-post border' >
                                                    <div className="card-noticia px-lg-4 mb-10 pt-5 pt-lg-0 ">

                                                        <div className="card-noticia__title"> <p> {item?.Categoria?.Title?.toUpperCase()} </p> </div>
                                                        <div onClick={() => Setlocation(item, true)} style={{ cursor: "pointer" }} className="card-noticia__img">
                                                            <a href={Setlocation(item, false)}>  <img src={ReplaceUrl(item?.UrlIcone)} onError={addDefaultSrcViver} alt="Imagem" /> </a>
                                                        </div>   
                                                                                                             
                                                        <div className="card-noticia__desc">
                                                            <a href={Setlocation(item, false)}> <h2 className="h4"> {item?.Title}</h2> </a>
                                                            <span>
                                                                {item?.Descricao}
                                                            </span>
                                                        </div>
                                                        <div className="card-noticia__data"> <p> {formatDateAno(item?.DataInicio)} </p>	</div>

                                                        <div onClick={() => Setlocation(item, true)} style={{ cursor: "pointer" }} className="card-noticia__link d-none d-lg-block">

                                                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>

                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-10 col-xl-12">
                                                {notFound === false && loadmore && loading === false && <div style={{ position: "relative" }}>
                                                    <button id="loadMore" style={{ position: "absolute", left: "50%", top: "45px", msTransform: "translate(-50%, -50%)", transform: "translate(-50%, -50%)" }} className="btn btn-primary py-4 px-5 rounded" onClick={() => loadMore()}>Carregar mais</button></div>}

                                                {notFound && <div className="container" id="notFound" style={{ position: "relative", left: "1%" }}>
                                                    <div className="row justify-content-center">
                                                        <div className="col-lg-10">
                                                            <div className="tabs mb-6 pt-8">
                                                                <div className='row align-items-strech'>
                                                                    <h3>Oops! Não encontramos nada.</h3>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="desktop">

                                        <div className="row">
                                            <div className="col-lg-10 col-xl-12">

                                            </div>
                                        </div>

                                        {loading &&
                                            <div className="container" id="loading" style={{ position: "relative", left: "35%" }}>
                                                <div className="row justify-content-center">
                                                    <div className="col-lg-10">
                                                        <div className="tabs mb-6 pt-8">
                                                            <div className='row align-items-strech'>
                                                                <PulseLoader size={20} color="#E87400" margin="4px" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}

                                        <br></br><br></br><br></br><br></br>
                                    </div>

                                    <div className="swiper-wrapper mobile">
                                        {
                                            <Swiper

                                                grabCursor={true}
                                                slidesPerView={"auto"}
                                                pagination={false}
                                                initialSlide={swiperIndex}
                                                // style={{ maxWidth: "30%", maxHeight: "50%", right: "26%" }}
                                                breakpoints={{
                                                    // when window width is >= 640px
                                                    384: {
                                                        width: 350,
                                                        slidesPerView: 1,
                                                    },
                                                    // when window width is >= 768px
                                                    590: {
                                                        width: 500,
                                                        slidesPerView: 2,
                                                    },
                                                }}
                                            >
                                                {noticias?.map((item: any, index: any) => (
                                                    <SwiperSlide key={index}>
                                                        <div key={index} className='col-lg-4 col-md-3 load-post border' >
                                                            <div className="card-noticia px-lg-4 mb-10 pt-5 pt-lg-0 ">

                                                                <div className="card-noticia__title"> <p> {item?.Categoria?.Title?.toUpperCase()} </p> </div>
                                                                <div onClick={() => Setlocation(item, true)} style={{ cursor: "pointer" }} className="card-noticia__img">
                                                                    <a href={Setlocation(item, false)}>  <img src={ReplaceUrl(item?.UrlIcone)} onError={addDefaultSrcViver} alt="Imagem" /> </a>
                                                                </div>
                                                                <div className="card-noticia__data"> <p> {formatDateAno(item?.DataInicio)} </p>	</div>
                                                                <div className="card-noticia__desc">
                                                                    <a href={Setlocation(item, false)}> <h2 className="h4"> {item?.Title}</h2> </a>
                                                                    <span>
                                                                        {item?.Descricao}
                                                                    </span>
                                                                </div>

                                                                <div onClick={() => Setlocation(item, true)} style={{ cursor: "pointer" }} className="card-noticia__link d-none d-lg-block">

                                                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                ))}


                                            </Swiper>
                                        }

                                    </div>
                                    <div className="col-12 d-lg-none mb-10 mobile">
                                        <div className="d-flex align-items-center justify-content-end">
                                            <div className={`swiper-button-prev swiper-button publicacoes-prev ${isPrevDisabled ? 'swiper-button-disabled' : ''}`}>
                                                <svg onClick={handlePrevClick} className="swiper-arrow swiper-arrow-prev" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
                                                </svg>
                                            </div>
                                            <div className={`swiper-button-next swiper-button noticias-next ${isNextDisabled ? 'swiper-button-disabled' : ''}`}>
                                                <svg onClick={handleNextClick} className="swiper-arrow swiper-arrow-next" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.172 7.00017L6.808 1.63617L8.222 0.222168L16 8.00017L8.222 15.7782L6.808 14.3642L12.172 9.00017H0V7.00017H12.172Z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ViverNoticias;

